// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__30vuY","col":"CardReaderDesc_col__lkmVc","label":"CardReaderDesc_label__3jtww"};